<template>
    <div ref="selfRef" v-if="searchStore.show"
         class="absolute z-50 w-full bg-white border border-gray-200 rounded-b-lg shadow-xl mt-[-4px]">
        <template v-if="searchStore.resultsLoaded">
            <div v-if="searchStore.results.length" class="max-h-80 overflow-y-auto">
                <Link v-for="result in searchStore.results" :key="result.id"
                      :href="route('product', result.slug)"
                      class="flex items-center gap-4 px-4 py-3 border-b md:hover:bg-gray-50 cursor-pointer transition">
                    <ImageLoader :src="'/storage/products/' + result.images[0]"
                                 :title="result.title"
                                 imgClasses="w-[70px] h-[70px] object-contain rounded-md border"/>
                    <div class="flex flex-col gap-1.5">
                        <div class="text-sm font-medium">
                            {{ result.title }}
                        </div>
                        <div class="flex gap-1 text-xs text-gray-500">
                            <div v-if="result.length"
                                 class="bg-grayBg px-2 py-1 rounded">
                                Длина: {{ result.length }}
                            </div>
                            <div v-if="result.length"
                                 class="bg-grayBg px-2 py-1 rounded">
                                Ширина: {{ result.width }}
                            </div>
                            <div v-if="result.length"
                                 class="bg-grayBg px-2 py-1 rounded">
                                Высота: {{ result.height }}
                            </div>
                        </div>
                        <div class="text-sm font-semibold text-gray-600">
                            Цена:
                            <NumberFormatComponent v-if="result.price"
                                                   :number="result.price"
                                                   append_text=" ₽"
                                                   class="text-yellow-600"/>
                            <div v-else>
                                Договорная
                            </div>
                        </div>
                    </div>
                </Link>
            </div>
            <div v-else
                 class="px-4 py-3 text-sm text-gray-500">
                {{ searchStore.query ? 'Ничего не найдено' : 'Введите для поиска' }}
            </div>
        </template>
        <template v-else>
            <SearchDesktopLoadingSkeleton v-for="i in 4"/>
        </template>

        <div v-if="searchStore.history.length" class="p-3 border-b text-sm text-gray-400">
            История
        </div>
        <ul v-if="searchStore.history.length">
            <li v-for="item in searchStore.history" :key="item"
                class="px-4 py-2 text-sm text-gray-700 md:hover:bg-grayBg flex justify-between items-center">
                <span @click.prevent="searchStore.repeatHistory(item)" class="cursor-pointer w-full">
                    {{ item }}
                </span>
                <button @click.stop.prevent="searchStore.removeFromHistory(item)"
                        class="group ml-2 text-gray-400 transition text-xs">
                    <IconX class="w-4 h-4 group-hover:stroke-red-600 transition"/>
                </button>
            </li>
        </ul>
    </div>
</template>

<script setup>
import {ref, watch, onMounted, onBeforeUnmount} from 'vue'
import {Link, router} from '@inertiajs/vue3'
import {useSearchStore} from '@js/store/SearchStore.js'
import NumberFormatComponent from '@js/components/Formatter/NumberFormatComponent.vue'
import ImageLoader from '@js/components/Loaders/ImageLoader.vue'
import IconX from '@js/components/Icons/IconX.vue'
import SearchDesktopLoadingSkeleton from '@js/components/Search/SearchDesktopLoadingSkeleton.vue'
import {isMobile} from '@js/helpers.ts'

const props = defineProps({
    inputRef: Object,
})

const searchStore = useSearchStore()
const selfRef = ref(null)

const handleClickOutside = (event) => {
    if (isMobile()) return

    const clickedEl = event.target
    const insideDropdown = selfRef.value?.contains(clickedEl)
    const insideInput = props.inputRef?.contains(clickedEl)

    if (!insideDropdown && !insideInput) {
        searchStore.show = false
    }
}

onMounted(() => {
    document.addEventListener('click', handleClickOutside)

    router.on('before', (event) => {
        searchStore.show = false
        searchStore.query = ''
    })
})

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside)
})

watch(
    () => searchStore.query,
    () => {
        searchStore.getSearchData()
    }
)
</script>
